import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { BranchService } from '../services/branch.service';

/**
 * Guardia Funcional para verificar si el usuario está autenticado.
 * Si la sesión es undefined (inicializando), espera por ella.
 */
export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const branchService = inject(BranchService);
  const router = inject(Router);

  let session = authService.session();

  // 1. Si la sesión aún se está inicializando (undefined), esperar
  if (session === undefined) {
    session = await firstValueFrom(
      toObservable(authService.session).pipe(
        filter(s => s !== undefined),
        take(1)
      )
    );
  }

  // 2. Si sabemos que no hay sesión, redirigir al login
  if (!session) {
    return router.createUrlTree(['/auth/login']);
  }

  // 3. Garantizar que el perfil está cargado
  await authService.refreshProfile();

  // 4. Garantizar que la sucursal ha sido resuelta (F5 o refresh directo)
  await branchService.initializeSession();

  return true;
};
